import styled from "@emotion/styled";
import ArrowDown from "@engineering/icons/arrow-down";
var DropdownWrapper = /*#__PURE__*/ styled("div", {
    target: "e17jk6lj0"
})("position:relative;display:flex;align-items:center;justify-content:center;");
var ArrowIcon = /*#__PURE__*/ styled(ArrowDown, {
    target: "e17jk6lj1"
})("position:absolute;right:0.9375rem;top:50%;transform:translateY(-50%);fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";width:1.6rem;height:1.6rem;pointer-events:none;");
var Hint = /*#__PURE__*/ styled("div", {
    target: "e17jk6lj2"
})("padding-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[30];
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.xxs.size;
}, ";");
var StyledLabel = /*#__PURE__*/ styled("label", {
    target: "e17jk6lj3"
})("position:absolute;top:-0.5625rem;left:0.75rem;z-index:2;margin:0;padding:0 0.25rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-size:0.75rem;line-height:1.5;overflow:hidden;pointer-events:none;text-overflow:ellipsis;white-space:nowrap;&:empty ~ select{padding-top:0.1875rem;padding-bottom:0.1875rem;}");
var StyledSelect = /*#__PURE__*/ styled("select", {
    target: "e17jk6lj4"
})("display:inline-block;position:relative;margin:0;padding:0.625rem 2rem 0.625rem 1rem;border:1px solid ", function(p) {
    return p.disabled ? "#e8e8e8" : "#c4c4c4";
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.sm;
}, ";outline:0;width:100%;height:3.125rem;font-size:1rem;line-height:1.5;color:", function(param) {
    var theme = param.theme, disabled = param.disabled;
    return disabled ? theme.color.natural30 : theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";appearance:none;&:hover{border-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";}");
export { DropdownWrapper, ArrowIcon, Hint, StyledLabel, StyledSelect };
